import RequestError from './RequestError';

const isRequestError = (value: unknown): value is RequestError => value instanceof RequestError;

export default isRequestError;
